import React from 'react'

import {
  Button,
  classnames,
  Icon,
  FavoriteFilled,
  FavoriteOutlined,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, number, bool, func } from 'prop-types'

function LikeDislikeButton({
  isLiked,
  isLoading = false,
  itemId,
  likeCount,
  onLike: handleLike,
  onUnlike: handleUnlike,
  useCaseId,
}) {
  const handleClick = async () => {
    if (isLoading) return

    if (isLiked) {
      return handleUnlike(itemId, useCaseId)
    }

    handleLike(itemId, useCaseId)
  }

  return (
    <Button
      customClass={
        classnames(
          'use-case-media-card__action-button',
          'use-cases-area__like-button',
        )
      }
      trailIcon={
        <Icon svgComponent={isLiked ? FavoriteFilled : FavoriteOutlined}/>
      }
      type="secondary"
      variant="with-icon"
      size="small"
      onClick={handleClick}
      disabled={isLoading}
      aria-label={isLiked ? 'Unlike' : 'Like'}
    >
      {likeCount}
    </Button>
  )
}

LikeDislikeButton.propTypes = {
  isLiked: bool.isRequired,
  isLoading: bool,
  itemId: number.isRequired,
  likeCount: number.isRequired,
  onLike: func.isRequired,
  onUnlike: func.isRequired,
  useCaseId: string.isRequired,
}

export default LikeDislikeButton
